module.exports = __webpack_public_path__ + "img/qrcode.b6b9cdfa.png";